import { Suspense } from "react";

import { graphql, useLazyLoadQuery } from "react-relay";

import { SettingsTabsLayout } from "../SettingsTabsLayout";
import { type AccessModelSettingsRootQuery } from "./__generated__/AccessModelSettingsRootQuery.graphql";
import { AccessModelSettings } from "./AccessModel/AccessModelSettings";
import { AccessModelSettingsPage } from "./AccessModelSettingsPage";

export function AccessModelSettingsRoot() {
  const data = useLazyLoadQuery<AccessModelSettingsRootQuery>(
    graphql`
      query AccessModelSettingsRootQuery {
        ...AccessModelSettings_awsAccessRoles
        ...AccessModelSettingsPage_query
      }
    `,
    {},
  );

  return (
    <AccessModelSettingsPage queryRef={data}>
      <SettingsTabsLayout>
        <div className="flex">
          <Suspense fallback={null}>
            <AccessModelSettings queryRef={data} />
          </Suspense>
        </div>
      </SettingsTabsLayout>
    </AccessModelSettingsPage>
  );
}
